/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './mp-product-modal.component.html';
import {MarketplaceProductOptionsResource} from '../../components/api/resources/resource/marketplace-product.resource';
import {MarketplaceProductResource} from '../../components/api/resources/resource/marketplace-product.resource';
import {interpolateTemplate} from '../common/filters/interpolate-template';
import {deferMarkForCheck} from '../common/util/defer-mark-for-check';

@Component({
  standalone: false,
  selector: 'adn-mp-product-modal',
  template
})
export class MpProductModalComponent implements OnInit {
  allProducts: any[] = [];
  initialAxProduct: any;
  isMarketplace = false;
  initialActiveTab: 'table' | 'block' = 'table';
  onSave: (axProduct: any, allAxProducts: any[]) => Promise<any>;
  onSaved: () => void;

  allAxProducts: any[] = [];
  activeTab: 'table' | 'block' = 'table';
  loading = false;
  axProduct: any;
  optionalTargetingTypes: string[] = [];
  layoutCategories: string[] = [];
  labels: string[] = [];
  adSizes: string[] = [];
  optionalTargetingType: string;
  layoutCategory: string;
  label: string;
  adSize: string;
  form: any = {};
  disabled = false;

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(MarketplaceProductOptionsResource) private readonly MarketplaceProductOptions: any,
    @Inject(MarketplaceProductResource) private readonly MarketplaceProduct: any,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.allAxProducts = this.allProducts || [];
    this.activeTab = this.initialActiveTab || (this.allAxProducts.length > 10 ? 'table' : 'block');
    this.axProduct = this.initialAxProduct;

    this.MarketplaceProductOptions.get((data: any) => {
      // Defer filter option lists — *ngIf="layoutCategories.length > 1" etc.
      // NG0100 if filled during modal checkNoChanges.
      deferMarkForCheck(this.cdr, () => {
        this.optionalTargetingTypes = data.optionalTargetingTypes;
        this.layoutCategories = data.layoutCategories;
        this.labels = data.labels;
        this.adSizes = _.orderBy(data.adSizes, (ad: string) => {
          return ad === 'ANY' ? 1 : parseInt(ad.split('x')[0], 10);
        });
      });
    });
  }

  selectAxProduct(prod: any): void {
    this.axProduct = prod;
  }

  filter(): void {
    const params: any = {};
    if (this.optionalTargetingType) {
      params.optionalTargeting = this.optionalTargetingType;
    }
    if (this.layoutCategory) {
      params.layoutCategory = this.layoutCategory;
    }
    if (this.label) {
      params.label = this.label;
    }
    if (this.adSize) {
      params.dimensions = this.adSize === 'ANY' ? '0x0' : this.adSize;
    }
    this.loading = true;
    this.MarketplaceProduct.query(params, (data: any) => {
      deferMarkForCheck(this.cdr, () => {
        this.allAxProducts = data.results;
        this.loading = false;
      });
    }, () => {
      deferMarkForCheck(this.cdr, () => {
        this.loading = false;
      });
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  saveAxProduct(): void {
    if (!this.axProduct) {
      this.dismiss();
      return;
    }
    if (!this.onSave) {
      this.dismiss();
      return;
    }

    this.disabled = true;
    this.form = {};
    this.onSave(this.axProduct, this.allAxProducts).then(() => {
      this.onSaved?.();
      this.bsModalRef.hide();
    }, (resp: any) => {
      this.form.validationError = true;
      this.form.apiErrors = _.map(_.get(resp, ['data', 'errors']), (errData: any) => {
        return {apiText: interpolateTemplate(errData.error.text)(errData.error.parameters)};
      });
      this.disabled = false;
    });
  }
}
